import * as React from 'react';
import styles from './H.module.css';
import cx from 'classnames';

const H1 = (props: React.PropsWithChildren<any>) => (
  <div className={cx(styles.h, styles.h1)}>{props.children}</div>
);
const H2 = (props: React.PropsWithChildren<any>) => (
  <div className={cx(styles.h, styles.h2)}>{props.children}</div>
);
const H3 = (props: React.PropsWithChildren<any>) => (
  <div className={cx(styles.h, styles.h3)}>{props.children}</div>
);

export { H1, H2, H3 };
